export const MAX_DEPTH: number = 64;
export const MAX_NODES: number = 10_000;
export const MAX_REFS: number = 1_000;
export const MAX_PROPERTIES: number = 5_000;
export const MAX_ENUM_VALUES: number = 1_000;
export const MAX_STRING_BUDGET: number = 120_000;
export const MAX_PATTERN_LENGTH: number = 256;
